import { SerializedStyles, css } from "@emotion/react";
import { Box } from "@mui/material";
import Link from "next/link";
import { FC } from "react";

import { formatDate } from "~/lib/graphql/graphqlClient";

type Database = {
  id: number;
  title: string;
  createdAt: string;
  categories: { id: number; name: string }[];
  postSize: number;
};

type Props = {
  database: Database;
  cssProps?: SerializedStyles;
};

const DatabasePanel: FC<Props> = ({
  database: { id, title, createdAt, categories, postSize },
  cssProps,
}) => {
  return (
    <Box
      css={[rootStyle, cssProps]}
      sx={{
        width: "256px",
        height: "373px",
      }}
    >
      <Link href={`/database/${id}`} css={panelContainerStyle}>
        <span css={createdAtContainerStyle}>
          Created At: {formatDate(createdAt)}
        </span>
        <span css={titleContainerStyle}>
          <span>{title}</span>
        </span>
      </Link>

      <div css={categoriesContainerStyle}>
        {categories.map((category) => (
          <Link
            href={`/category/${category.id}`}
            key={category.id}
            css={categoryLinkStyle}
          >
            {category.name}
          </Link>
        ))}
      </div>

      <div css={postSizeContainerStyle}>{postSize} data</div>
    </Box>
  );
};

const rootStyle = css`
  position: relative;
  background: linear-gradient(to bottom, #ffffff, #eaeaea);
  border-radius: 10px;
  color: #000a14;
  display: flex;
  font-weight: bold;
  flex-flow: column;
  padding: 0.813rem 16px 1.5rem;
  line-height: 1.3;

  &::before {
    background-image: url("/images/common/boardPanelIcon.svg");
    content: "";
    height: 24px;
    left: 8px;
    position: absolute;
    top: 0.438rem;
    width: 24px;
  }
`;

const panelContainerStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const createdAtContainerStyle = css`
  display: block;
  font-size: 0.625rem;
  text-align: right;
  flex-shrink: 0;
`;

const titleContainerStyle = css`
  display: flex;
  font-size: 24px;
  flex: 1;
  margin-top: 69px;
`;

const categoriesContainerStyle = css`
  display: flex;
  flex-flow: row wrap;
  margin-top: auto;
`;

const categoryLinkStyle = css`
  color: #535353;
  font-size: 0.75rem;
  margin-bottom: 8px;
  margin-right: 4px;
`;

const postSizeContainerStyle = css`
  font-size: 1.5rem;
`;

export default DatabasePanel;
